import React, { useState, useEffect } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Paper,
  DialogContentText
} from "@mui/material";

import Draggable from "react-draggable";

import CRUDPageHeader from "../../components/CRUDPageHeader";
import BancoFiltrosForm, { BANCO_FILTROS_FORM_ID } from "src/forms/BancoFiltrosForm";
import { atualizarBancoFiltro, buscarBancoFiltros, cadastrarBancoFiltro, deletarBancoFiltro } from "../../services/api-conciliacao.service";
import { buscarMinhasPermissoes } from "../../services/api-autenticacao.service";
import { aplicarFiltroBancoFiltros } from "../../utils/bancoFiltros.util";

function formatarCnpjExibicao(cnpj) {
  const d = String(cnpj ?? "").replace(/\D/g, "");
  if (d.length !== 14) return cnpj;
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

function formatarCnpjsLista(cnpjs) {
  if (!Array.isArray(cnpjs) || cnpjs.length === 0) return "Todas";
  return cnpjs.map((c) => formatarCnpjExibicao(c)).join(", ");
}

function enriquecerLinhasBancoFiltros(linhas) {
  return (linhas ?? []).map((row) => ({
    ...row,
    cnpjs_label: formatarCnpjsLista(row.cnpjs),
  }));
}


function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const BancoFiltros = () => {
  const [data, setData] = useState([]);
  const [dataCompleta, setDataCompleta] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [loading, setLoading] = useState(false)
  const [permiteTodosCnpj, setPermiteTodosCnpj] = useState(false);

  const columns = [
    {
      id: "banco_label",
      label: "Banco",
      field: "banco_label",
      width: "13%",
    },
    { id: "filtro", label: "Filtro", field: "filtro", width: "23%" },
    {
      id: "cnpjs_label",
      label: "CNPJs",
      field: "cnpjs_label",
      width: "15%",
    },
    {
      id: "conta_dominio_label",
      label: "Conta Domínio",
      field: "conta_dominio_label",
      width: "15%",
    },
    {
      id: "conta_protheus_label",
      label: "Conta Protheus",
      field: "conta_protheus_label",
      width: "15%",
    },
    {
      id: "usuario_label",
      label: "Usuário",
      field: "usuario_label",
      width: "15%",
    },
  ];

  useEffect(() => {
    handleAtualizar()
  }, [])

  useEffect(() => {
    buscarMinhasPermissoes()
      .then((response) => {
        const permissoes = response?.permissoes ?? [];
        setPermiteTodosCnpj(
          permissoes.includes("todos_cnpj") || Boolean(response?.grupoTecnico) || Boolean(response?.superAdmin)
        );
      })
      .catch(() => setPermiteTodosCnpj(false));
  }, [])

  const handleOpenModal = (rowData) => {
    const isLinha =
      rowData &&
      typeof rowData === "object" &&
      rowData.id_conciliacao_filtro_vinculo_conta != null;
    setEditRowData(isLinha ? rowData : {});
    setOpenModal(true);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAtualizar = async () => {
    setLoading(true)
    try {
      const response = await buscarBancoFiltros();
      const linhas = enriquecerLinhasBancoFiltros(response.filtrosVinculoContas);
      setDataCompleta(linhas);
      setData(linhas);
      setLoading(false)
    } catch (err) {
      if (err.response) {
        setMsg(err.response.data.mensagem);
        handleOpenSnackbarErro();
      } else {
        setMsg("Erro: Tente novamente!");
        handleOpenSnackbarErro();
      }
      setLoading(false)
    }
  }

  const handleSaveChanges = async (data) => {

    if (!editRowData.id_conciliacao_filtro_vinculo_conta) {
      // Cadastra
      await cadastrarBancoFiltro(data)
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    } else {
      await atualizarBancoFiltro(editRowData.id_conciliacao_filtro_vinculo_conta, data)
        .then(async (response) => {
          setMsg(response.data?.mensagem ?? response.mensagem);
          handleOpenSnackbarSucesso();
          handleAtualizar();
          handleCloseModal();
        })
        .catch((err) => {
          if (err.response) {
            setMsg(err.response.data?.mensagem ?? err.response.mensagem);
            handleOpenSnackbarErro();
          } else {
            setMsg("Erro: Tente novamente!");
            handleOpenSnackbarErro();
          }
        });
    }
  };

  const handleDelete = async () => {
    //Deleta
    await deletarBancoFiltro(editRowData.id_conciliacao_filtro_vinculo_conta)
      .then(async (response) => {
        setMsg(response.data?.mensagem ?? response.mensagem);
        // Buscar dados novamente para renderizar
        handleOpenSnackbarSucesso()
        handleAtualizar();
        handleCloseDialogExclusao();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.data.mensagem);
          handleOpenSnackbarErro();
        } else {
          setMsg("Erro: Tente novamente!");
          handleOpenSnackbarErro();
        }
      });
  };


  const handleDebounceChange = (event) => {
    const texto = String(event.target.value ?? "").trim();
    setData(aplicarFiltroBancoFiltros(dataCompleta, texto));
  };


  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };


  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };



  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleSubmitBancoFiltrosForm = () => {
    document.getElementById(BANCO_FILTROS_FORM_ID)?.requestSubmit();
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={<>
          <AccountBalanceIcon />
        </>}
        headerTitle="Vínculos de contas"
        modalButtonLabel={"Adicionar"}
        handleOpenModal={handleOpenModal}
        handleDebounceChange={handleDebounceChange}
      />


      <TabelaDinamica
        data={data}
        columns={columns}
        loading={loading}
        fixedLayout
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />
      <Dialog
        open={openModal}
        onClose={(_event, reason) => {
          if (reason === "backdropClick") return;
          handleCloseModal();
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: { maxWidth: 740, overflow: "visible" },
        }}
      >
        <DialogTitle sx={{ pt: 1.5, pb: 1, px: 3 }}>
          <div className={styles.modalHeader}>
            <div className={styles.tituloPopupContainer}>
              <AccountBalanceIcon fontSize="30px" />
              <h1 className={styles.tituloPopup}>Banco Filtro</h1>
            </div>
            <div className={styles.modalHeaderAcoes}>
              <Button
                className={styles.botaoPopupCancelarHeader}
                onClick={handleCloseModal}
                size="small"
              >
                Cancelar
              </Button>
              <Button
                className={styles.botaoPopupSalvarHeader}
                type="button"
                onClick={handleSubmitBancoFiltrosForm}
                size="small"
              >
                Salvar
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{ m: 0, p: 0 }}>
          <BancoFiltrosForm
            bancoFiltrosValues={Object.assign({}, editRowData)}
            onSubmit={handleSaveChanges}
            permiteTodosCnpj={permiteTodosCnpj}
          />
        </DialogContent>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
          Você realmente deseja excluir permanentemente o filtro{" "}
            "{editRowData.filtro}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default BancoFiltros;
